import React from "react";
import styled from "styled-components";

type SizeVariant = "normal" | "small";

type ProjectAvatarProps = {
    className?: string;
    variant?: SizeVariant;
    children: React.ReactNode;
};

const ProjectAvatar = ({
    className,
    variant = "normal",
    children,
}: ProjectAvatarProps): JSX.Element => {
    return (
        <Container variant={variant} className={className}>
            <Initial variant={variant} className="mb-0">
                {children}
            </Initial>
        </Container>
    );
};

const Container = styled.div<{ variant: SizeVariant }>`
    // box-shadow: 0 2px 16px rgba(169, 169, 169, 0.25);
    border: 1px solid #333333;
    background-color: var(--bs-light);
    text-align: center;
    

    ${(props) =>
        props.variant === "normal" &&
        `
        width: 56px;
        height: 56px;
        border-radius: 0;
    `}

    ${(props) =>
        props.variant === "small" &&
        `
        width: 36px;
        height: 36px;
        border-radius: 0;
    `}
`;

const Initial = styled.span<{ variant: SizeVariant }>`
    background: -webkit-linear-gradient(#333333, #333333);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    ${(props) =>
        props.variant === "normal" &&
        `
        font-size: 2rem;
        line-height: 56px;
    `}

    ${(props) =>
        props.variant === "small" &&
        `
        font-size: 1.5rem;
        line-height: 36px;
    `}
`;

export default ProjectAvatar;
